import { render, staticRenderFns } from "./BirthdayScreen.vue?vue&type=template&id=79c8a46f&scoped=true&"
import script from "./BirthdayScreen.vue?vue&type=script&lang=js&"
export * from "./BirthdayScreen.vue?vue&type=script&lang=js&"
import style0 from "./BirthdayScreen.vue?vue&type=style&index=0&id=79c8a46f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c8a46f",
  null
  
)

export default component.exports